import { render, staticRenderFns } from "./StepBasics.vue?vue&type=template&id=636cd038"
import script from "./StepBasics.vue?vue&type=script&lang=js"
export * from "./StepBasics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports